/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_CamerasInputs */

const he_home_category_cameras = /** @type {(inputs: Home_Category_CamerasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מצלמות`)
};

const en_home_category_cameras = /** @type {(inputs: Home_Category_CamerasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cameras`)
};

/**
* | output |
* | --- |
* | "Cameras" |
*
* @param {Home_Category_CamerasInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_cameras = /** @type {((inputs?: Home_Category_CamerasInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_CamerasInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_cameras(inputs)
	return en_home_category_cameras(inputs)
});